import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth } from "../../../utils/api-service";
import { EXTENSION_URI, APP_VIEW } from "../../../constants/constant";

export const fetchErrors = createAsyncThunk(
  "errorsExtension/fetchErrors",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(EXTENSION_URI, { view: APP_VIEW.ERRORS });
      return response.data?.extensionRequestList || [];
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch errors");
    }
  }
);

const initialState = {
  errors: [],
  loading: false,
  error: null,
};

const errorsExtensionSlice = createSlice({
  name: "errorsExtension",
  initialState,
  reducers: {
    clearErrorsError: (state) => {
      state.error = null;
    },
    resetErrors: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchErrors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchErrors.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(fetchErrors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearErrorsError,
  resetErrors,
} = errorsExtensionSlice.actions;

export default errorsExtensionSlice.reducer;
